<template>
  <div class="base-body system-check-c">
    <div class="check-title clearfix">
      <h1 class="floatL">审批列表</h1>
      <div class="custom-btn floatR">
        <el-button type="primary" @click="savePermission" v-if="!isShow">保存</el-button>
        <el-button type="info" @click="$router.back()">取消</el-button>
      </div>
    </div>
    <div class="auto-con">
      <div class="content">
        <div class="item">
          <h1 class="header sub">提交人</h1>
          <p class="name-a">申请人</p>
        </div>
        <template v-for="(data, i) in list">
          <div class="pro-add" :key="`${i}_add`">
            <img :src="require('@/assets/images/jiantou.png')" />
            <i class="iconfont icontianjia" @click="addApproveUser(i)" v-if="!isShow"></i>
          </div>
          <div class="item" :key="`${i}_user`">
            <h1 class="header shen">审批人
              <i class="iconfont iconguanbi floatR" @click="removeUser(i)" v-if="!isShow"></i>
            </h1>
            <template v-if="data.setting_type === 0">
              <p class="name-a" @click="toCheckUser(data, i)">
                {{'请选择审批人'}}
                <i class="iconfont iconarrowright"></i>
              </p>
            </template>
            <template v-else-if="data.setting_type === 1">
              <div class="name-a" @click="toCheckUser(data, i)">
                <div class="user-list widthAll">
                  <p class="user-name">{{`${data.approval_admin_type_name} 部门负责人`  || '请选择审批人'}}</p>
                  <i class="iconfont iconarrowright"></i>
                </div>
              </div>
            </template>
            <template v-else-if="data.setting_type === 2">
              <div class="name-a" @click="toCheckUser(data, i)">
                <div class="user-list">
                  <p class="user-name">{{`${data.approval_admin_type_name}`  || '请选择审批人'}}</p>
                  <span class="user-total">共{{getPersonList(data)}}人</span>
                  <i class="iconfont iconarrowright"></i>
                </div>
              </div>
            </template>
            <template v-else-if="data.setting_type === 3">
              <div class="name-a" @click="toCheckUser(data, i)">
                <div class="user-list">
                  <p class="user-name">{{`${data.approval_admin_type_name}`  || '请选择审批人'}}</p>
                  <i class="iconfont iconarrowright"></i>
                </div>
              </div>
            </template>
          </div>
        </template>
        <div class="pro-finish">
          <img :src="require('@/assets/images/jieshu.png')" />
          <i class="iconfont icontianjia" @click="addApproveUser(list.length)" v-if="!isShow"></i>
          <span class="label-b">流程结束</span>
        </div>
      </div>
    </div>

    <system-operate-member ref="systemOperateMember" @callback="callback" @permissionBack="permissionBack" />
  </div>
</template>
<script>
import SystemOperateMember from './components/operateMember';
import {getApproveDetail, setApproveProcess} from '@/api/system';
export default {
  name: 'ApproveSettingList',
  components: {
    SystemOperateMember
  },
  data () {
    return {
      list: [],
      isShow: false
    }
  },
  mounted () {
    this.initList();
    const {isShow} = this.$route.query;
    this.isShow = isShow === 'isShow';
  },
  methods: {
    open () {
      this.$refs.systemOperateMember && this.$refs.systemOperateMember.open();
    },
    async initList () {
      const {type} = this.$route.query;
      if (!(!!type)) return null;
      try {
        const res = await getApproveDetail(type, {
          voucherType: type
        })
        this.list = res || [];
      } catch (error) {
        this.$message.error(error.msg || '获取审批节点出现错误');
      }
    },
    removeUser (index) {
      this.list.splice(index, 1);
    },
    addApproveUser (index) {
      if (this.list.length >= 7) {
        this.$message.error('最多可设置7级审批');
        return null;
      }
      this.list.splice(index, 0, {
        name: '审批人',
        edit_setting: 1,
        setting_type: 0
      });
    },
    toCheckUser (data, index) {
      this.$refs.systemOperateMember && this.$refs.systemOperateMember.open(data, index);
    },
    getPersonList (data) {
      return (data.approval_admin_list + '' || '').split(',').length || 0;
    },
    callback (data = {}, index) {
      Object.keys(data).map(v => this.$set(this.list[index], v, data[v]));
    },
    permissionBack (type, index) {
      this.$set(this.list[index], 'edit_setting', type);
    },
    async savePermission () {
      // 校验数据
      const size = this.list.filter(v => !(!!v.approval_admin_type_name));
      if (size.length > 0 || this.list.length <= 0) {
        this.$message.error('请先选择审批人');
        return null;
      }
      try {
         const {type} = this.$route.query;
        if (!(!!type)) return null;
        await setApproveProcess(type, {
          voucherType: type,
          setting: this.list
        });
        this.$message.success('设置审批成功');
        this.$router.back();
      } catch (error) {
        this.$message.error(error.msg || '操作失败，请稍候');
      }
    }
  }
}
</script>
<style lang="less">
@import url('~@/assets/style/system.less');
</style>
<style scoped lang="less">
.user-list{
  width: 90%;
  margin: 0 auto;
  .box(start, start);
  .user-name{
    .ellipse(1);
    .boxFlexAll();
  }
  .user-total{
    color: #999;
    font-size: 13px;
    display: block;
    padding-left: 10px;
  }
}
.user-list.widthAll{
  width: 100%;
}
</style>